import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@travel.com");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/");
    } catch (err) {
      const msg = formatApiError(err?.response?.data?.detail) || err.message;
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-[#F4F7FB]">
      {/* Image side */}
      <div className="relative hidden lg:block">
        <img
          src="https://images.pexels.com/photos/14036444/pexels-photo-14036444.jpeg"
          alt="Travel"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/30" />
        <div className="relative h-full flex flex-col justify-end p-12 text-white">
          <div className="overline text-white/80 mb-3">Travelhostic Travel CRM</div>
          <h1 className="font-display text-5xl leading-tight max-w-md">
            Send beautiful, perfectly timed travel emails.
          </h1>
          <p className="mt-4 text-white/80 max-w-md text-sm">
            Manage travelers, curate packages, and orchestrate email campaigns from one elegant dashboard.
          </p>
        </div>
      </div>

      {/* Form side */}
      <div className="flex items-center justify-center p-8">
        <form onSubmit={onSubmit} className="w-full max-w-md space-y-6" data-testid="login-form">
          <div>
            <div className="overline mb-3">Welcome back</div>
            <div className="flex items-center gap-3 mb-2">
              <img src="/travelhostic-mark.png" alt="Travelhostic" className="w-12 h-12 object-contain" />
              <h2 className="font-display text-4xl text-[#0F172A]">Sign in</h2>
            </div>
            <p className="text-[#64748B] mt-2 text-sm">
              Don&apos;t have an account?{" "}
              <Link to="/register" className="text-[#1E3A8A] underline" data-testid="register-link">
                Create one
              </Link>
            </p>
          </div>

          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email-input"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password-input"
              />
            </div>
          </div>

          {error && (
            <div className="text-sm text-[#DC2626] bg-[#DC2626]/10 px-3 py-2 rounded-lg" data-testid="login-error">
              {error}
            </div>
          )}

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#1E3A8A] hover:bg-[#172A6B] text-white"
            data-testid="login-submit-btn"
          >
            {loading ? "Signing in..." : "Sign in"}
          </Button>

          <div className="text-xs text-[#64748B] pt-4 border-t border-[#E2E8F0]">
            Default admin: <strong>admin@travel.com</strong> / <strong>admin123</strong>
          </div>
        </form>
      </div>
    </div>
  );
}
